import { create } from 'zustand';
import type { ReactNode } from 'react';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export interface ToastItem {
  id: string;
  variant: ToastVariant;
  title: string;
  description?: string;
  duration?: number;
  action?: ReactNode;
}

export type ToastInput = Omit<ToastItem, 'id'>;

const MAX_VISIBLE = 3;

interface ToastStoreState {
  toasts: ToastItem[];
  push: (toast: ToastInput) => void;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastStoreState>()((set) => ({
  toasts: [],
  push: (toast) =>
    set((state) => ({
      // Newest at the bottom; drop the oldest when exceeding the visible cap.
      toasts: [...state.toasts, { ...toast, id: crypto.randomUUID() }].slice(-MAX_VISIBLE),
    })),
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
